module.exports = __webpack_public_path__ + "static/media/win.ffa08e71.mp3";